module.exports = __webpack_public_path__ + "static/CharacterHorizontal2-580d154e754cdc4e59a0a30f781a3123.png";